import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
  min-width: 0;
  flex-direction: column;
  gap: 24px;
`;

export const Title = styled.h1`
  flex: 0 0 auto;
  color: #181818;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const TableScope = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  overflow: hidden;

  & > div {
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
    gap: 0;
  }

  .p-datatable-thead > tr > th {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }

  .p-datatable-tbody > tr > td {
    height: 112px;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
`;

export const PreviewImage = styled.img`
  display: block;
  width: auto;
  height: auto;
  max-width: 100px;
  max-height: 100px;
`;

export const ViewButton = styled.button`
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #005fb8;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 6px 10px;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    background: #ebf4ff;
  }

  & i {
    font-size: 14px;
  }
`;
